const state = {
    isLoading: false,
    direction: ''
}
const getters = {}
const actions = {
    setIsLoading (options, flag) {
        options.commit('setIsLoading', flag)
    }
}
const mutations = {
    setIsLoading (state, flag) {
        state.isLoading = flag
    },
    updateDirection (state, direction) {
        state.direction = direction
    }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js